"use client";
function m(t, i) {
  if (!t)
    return;
  if (!i)
    return t;
  const n = i.trim(), r = [n, `<em>${n}</em>`].find((e) => t.startsWith(e));
  return r ? t.slice(r.length).trim() : t;
}
export {
  m as descriptionWithoutTitle
};
